import FormField from './form_field';
import FormFieldFactory from './form_field_factory';
import GridFormAction from '../action/grid_form_action';
import FormActionTypes from '../../constants/form_action_types';

import GridFormDefaultActions from 'grid_form/constants/grid_form_default_actions';

export default class GridFormField extends FormField {
	_fields;
	_columns;
	_gridDataStoreRoute;
	_fieldGroupingId;

	constructor(fieldProps = {}) {
		super(fieldProps);

		this._fields = this._buildFormFields(fieldProps.fields);
		this._actions = this._buildDefaultGridFormFieldActions();
	}

	_buildFormFields(fields) {
		return fields
		? fields.map((field) => FormFieldFactory.create(Object.assign({
			formId: this._formId,
			type: FormActionTypes.GRID
		}, field)))
		: [];
	}

	_buildDefaultGridFormFieldActions() {
		return GridFormDefaultActions.map((action) => new GridFormAction(Object.assign({
			formId: this._formId,
			type: FormActionTypes.GRID
		}, action)));
	}

	get fields() {
		return this._fields;
	}

	set fields(fields) {
		this._fields = this._buildFormFields(fields);
	}

	get columns() {
		return this._columns;
	}

	set columns(value) {
		this._columns = value;
	}

	get gridDataStoreRoute() {
		return this._gridDataStoreRoute;
	}

	set gridDataStoreRoute(value) {
		this._gridDataStoreRoute = value;
	}

	get fieldGroupingId(){
		return this._fieldGroupingId;
	}

	set fieldGroupingId(value){
		this._fieldGroupingId = value;
	}
}
